/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="94.95"
        height="95.43"
        viewBox="0 0 94.95 95.43"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M9.94 9.94a33.94 33.94 0 1 0 48 0 33.95 33.95 0 0 0-48 0Zm46.23 1.77a31.18 31.18 0 1 1-.37-.37Z"/>
        <path
          fill="#fefefe"
          d="m93.7 86.04-8.14 8.14-25.6-25.61 8.13-8.13 25.61 25.6z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="m67.21 59.55-8.13 8.14a1.25 1.25 0 0 0 0 1.77l25.6 25.6a1.25 1.25 0 0 0 1.77 0l8.13-8.13a1.25 1.25 0 0 0 0-1.77L69 59.55a1.27 1.27 0 0 0-1.79 0Zm.88 2.66 23.84 23.83-6.37 6.37-23.83-23.84Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="m59.77 55.3 6.25 6.25-4.95 4.95-6.25-6.25 4.95-4.95z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M32 13.34v3.57l-.55.11-.56.11a8.57 8.57 0 0 0-6.45 5.24 10.71 10.71 0 0 0-.75 4.88 8.37 8.37 0 0 0 4.49 7.13 36 36 0 0 0 3.75 1.68c1.57.66 3.17 1.27 4.73 1.94a2.85 2.85 0 0 1 1.79 3.12 3.12 3.12 0 0 1-2.51 3.13 9.38 9.38 0 0 1-2 .21 4.92 4.92 0 0 1-5-3.68c-.14-.44-.25-.89-.39-1.37l-6 1.54a12.47 12.47 0 0 0 2.89 5.93 10.11 10.11 0 0 0 6.57 3v4.62h3.87v-4.55c.78-.16 1.54-.28 2.27-.47a8.93 8.93 0 0 0 6.31-5.11 10.41 10.41 0 0 0 .72-6.25A8.22 8.22 0 0 0 41 32.18a47.81 47.81 0 0 0-5.73-2.51c-1.17-.46-2.32-1-3.45-1.56a2.49 2.49 0 0 1-1.29-1.56 3.49 3.49 0 0 1 2.47-4.4 4 4 0 0 1 4 1 7.7 7.7 0 0 1 1.63 2.47c.14.29.26.58.39.9l5.37-2.21a10.92 10.92 0 0 0-2-4 9.41 9.41 0 0 0-6.51-3.39v-3.58Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'MagnifyingGlassWithDollarSignIcon';

export default Icon;
